import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { CREATE_EDIT_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import PreviewPurchaseOrderComponent from '../../components/createEditPurchaseOrder/PreviewPurchaseOrder';
import connect from 'react-redux/es/connect/connect';
import { CreateEditPurchaseOrderEnum } from 'Common/FieldEnum';

class PreviewPurchaseOrderContainer extends Component {
  render() {
    return <PreviewPurchaseOrderComponent {...this.props} />;
  }
}

const mapStateToProps = state => {
  const selector = formValueSelector(CREATE_EDIT_PURCHASE_ORDER_FORM_NAME);
  return {
    poItemDetails: selector(state, [CreateEditPurchaseOrderEnum.POItemDetails]),
  };
};

PreviewPurchaseOrderContainer = reduxForm({
  form: CREATE_EDIT_PURCHASE_ORDER_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PreviewPurchaseOrderContainer);

export const PreviewPurchaseOrder = connect(
  mapStateToProps,
  null
)(PreviewPurchaseOrderContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/containers/createEditPurchaseOrder/PreviewPurchaseOrder.js